export const CREATE_DISTRIBUTOR_URL = '/distributors';
export const GET_DISTRIBUTORS_URL = '/distributors';
export const GET_DISTRIBUTOR_DETAILS_URL = (id) => `/distributors/${id}`;
export const GET_DISTRIBUTOR_SONGS_URL = (id) => `/distributors/${id}/songs`;
export const GET_DISTRIBUTOR_CONFLICTS_URL = (id) => `/distributors/${id}/conflicts`;
export const GET_DISTRIBUTOR_LABELS_URL = (id) => `/distributors/${id}/labels`;
export const UPDATE_DISTRIBUTOR_URL = (id) => `/distributors/${id}`;
export const INACTIVATE_DISTRIBUTOR_URL = (id) => `/distributors/${id}/inactivate`;
export const ACTIVATE_DISTRIBUTOR_URL = (id) => `/distributors/${id}/activate`;
export const DELETE_DISTRIBUTOR_URL = (id) => `/distributors/${id}`;
